'use client';

import dynamic from 'next/dynamic';

// Dynamically load the entire studio with its config
const StudioLoader = dynamic(() => import('./studio-loader'), {
  ssr: false,
  loading: () => <div>Loading Studio...</div>,
});

export default function StudioClient() {
  return <StudioLoader />;
}
